export default __webpack_public_path__ + "static/pala-1-294345baee72eaabfc56a02317573d01.jpg";